import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { FlexLayoutModule } from "@angular/flex-layout";
import { MatCardModule } from "@angular/material/card";
import { MatIconModule } from "@angular/material/icon";
import { AdditionalInterest, CoverageItem, PolicyTrackerData } from "../policy-tracker.interfaces";
import { CoverageType, CoverageIcons } from "../policy-status.constants";

@Component({
  selector: "app-policy-tracker-info",
  standalone: true,
  imports: [CommonModule, MatCardModule, MatIconModule, FlexLayoutModule],
  templateUrl: "./policy-tracker-info.component.html",
  styleUrls: ["./policy-tracker-info.component.scss"],
})
export class PolicyTrackerInfoComponent {
  @Input() policy!: PolicyTrackerData;

  @Input() additionalInterests: AdditionalInterest[] = [
    {
      name: "Mountainview Apartments",
      address: "123 Main Street, Portland, OR 97201",
      type: "Property Manager",
    },
  ];

  @Input() coverageItems: CoverageItem[] = [
    {
      type: CoverageType.PersonalProperty,
      amount: 25000,
      icon: CoverageIcons[CoverageType.PersonalProperty],
    },
    {
      type: CoverageType.PersonalLiability,
      amount: 100000,
      icon: CoverageIcons[CoverageType.PersonalLiability],
    },
    {
      type: CoverageType.MedicalPayments,
      amount: 1000,
      icon: CoverageIcons[CoverageType.MedicalPayments],
    },
    {
      type: CoverageType.LossOfUse,
      amount: 5000,
      icon: CoverageIcons[CoverageType.LossOfUse],
    },
  ];

  hasValidAmount(amount: any): boolean {
    return amount && String(amount).trim().length > 0;
  }

  getIcon(type: CoverageType): string {
    return CoverageIcons[type] ?? "help_outline";
  }
}
